import * as THREE from "three";

/**
 * Handles collision detection for procedural walls
 * Updates octree mesh positions based on wall visibility
 * @param appData Application data containing scene and physics information
 */
export function handleProcedrualWallCollision(appData: any) {
    const octreeHelper = appData.spaceScene.getObjectByName("octree-mesh")
    appData.spaceScene.traverse((child: any) => {
        if (child.name.startsWith("Space-")) {
            const extraMesh = octreeHelper.getObjectByName("octree-mesh-" + child.name)
            if (extraMesh) {
                if (child.visible) {
                    extraMesh.position.y = -100
                } else {
                    extraMesh.position.y = 0
                }
            }
        }
    })
    // appData.physicsService.init()
    appData.physicsService.setCollision(octreeHelper)
}

/**
 * Manages visibility of procedural spaces and their entry points
 * Updates space visibility based on procedural parameters
 * @param appData Application data containing gallery and space information
 * @returns Array of artworks that should be hidden
 */
export function handleProceduralSpaceVisibility(appData: any) {
    const proceduralParams = appData.galleryData.data.spaceProceduralParameters
    appData.physicsService.dispose()
    appData.spaceScene.traverse((child: any) => {
        if (child.name.startsWith("Space-")) {
            child.visible = false
            // verify if the space should be visible
            for (let index = 0; index < proceduralParams.length; index++) {
                const proceduralParamSpaceVisibility = proceduralParams[index];

                // check if the current space matches the current id from appdat
                if (child.userData.spaceID === index && proceduralParamSpaceVisibility) {
                    child.visible = true
                }
            }

            // check if it has any entryPoints
            for (let index = 0; index < child.children.length; index++) {
                const childrenOfSpace = child.children[index];
                if (appData.galleryData.editable) {
                    if (childrenOfSpace.name.includes("entryTo_")) {
                        // check if the entry point to is visible. If it is, hide the entry point, if it's not show it
                        const targetSpaceNo = childrenOfSpace.userData.makeVisibleSpace

                        let targetSpaceNumber = targetSpaceNo.split("-").pop();
                        let targetSpaceNumberFormtted = Number(targetSpaceNumber) - 1

                        for (let index = 0; index < proceduralParams.length; index++) {
                            const proceduralParamSpaceVisibility = proceduralParams[index];

                            // check if the current space matches the current id from appdat
                            if (index === targetSpaceNumberFormtted) {
                                if (proceduralParamSpaceVisibility) {
                                    // the target space is visible, hide all entries to it
                                    childrenOfSpace.visible = false
                                    // childrenOfSpace.children[0].visible = true // hide the text

                                } else {
                                    // the target space is not visible, show all entries to it
                                    childrenOfSpace.visible = true
                                    // childrenOfSpace.children[0].visible = false // hide the text
                                }
                            }
                        }
                    }
                } else {
                    if (childrenOfSpace.name.includes("remove_")) {
                        childrenOfSpace.visible = false
                    } else if (childrenOfSpace.name.includes("entryTo_")) {
                        const targetSpaceNo = childrenOfSpace.userData.makeVisibleSpace

                        let targetSpaceNumber = targetSpaceNo.split("-").pop();
                        let targetSpaceNumberFormtted = Number(targetSpaceNumber) - 1

                        for (let index = 0; index < proceduralParams.length; index++) {
                            const proceduralParamSpaceVisibility = proceduralParams[index];

                            // check if the current space matches the current id from appdat
                            if (index === targetSpaceNumberFormtted) {
                                if (proceduralParamSpaceVisibility) {
                                    // the target space is visible, hide all entries to it
                                    childrenOfSpace.visible = false
                                    // childrenOfSpace.children[0].visible = true // hide the text

                                } else {
                                    // the target space is not visible, show all entries to it
                                    childrenOfSpace.visible = true
                                    // childrenOfSpace.children[0].visible = false // hide the text
                                    //   childrenOfSpace.visible = true
                                    const zValue = 1000
                                    childrenOfSpace.position.y = -(zValue)
                                    if (childrenOfSpace.children[0]) {
                                        childrenOfSpace.children[0].position.z = -(zValue + 1.825)
                                    }
                                }
                            }
                        }

                    }

                }

            }

        }
    })
    handleProcedrualWallCollision(appData)
    let artworksToHide = handleArtworksVisibilityForProcedrualSpace(appData)

    // let artworksToHide = []
    return artworksToHide
}

/**
 * Controls artwork visibility in procedural spaces
 * Shows/hides artworks based on their owner space's visibility
 * @param appData Application data containing artwork and space information
 * @returns Array of artworks that were hidden
 */
export function handleArtworksVisibilityForProcedrualSpace(appData: any) {
    const proceduralParams = appData.galleryData.data.spaceProceduralParameters
    const artworkSceneChildren = appData.artworksScene.children

    let artworksToHide = []
    for (let index = 0; index < artworkSceneChildren.length; index++) {
        const artworkChild = artworkSceneChildren[index];
        if (artworkChild.type === "Object3D") {
            const artworkChildUserData = artworkChild.userData
            if (artworkChildUserData) {
                let shouldBeVisible = true;
                let hiddenBySpace = false;
                const ownerID = Number((artworkChildUserData.owner || '').split('Space-').pop()) - 1
                if (ownerID >= 0 && ownerID < proceduralParams.length && !proceduralParams[ownerID]) {
                    shouldBeVisible = false;
                    hiddenBySpace = true;
                }
                if (artworkChildUserData.dependency && artworkChildUserData.dependency.length > 0) {
                    let dependencyObject = appData.spaceScene.getObjectByName(artworkChildUserData.dependency);
                    if (dependencyObject) {
                        // Only allow dependency to hide; never override a hidden-by-space artwork to visible.
                        shouldBeVisible = shouldBeVisible && dependencyObject.visible;
                    }
                }
                if (artworkChild.visible !== shouldBeVisible) {
                    artworkChild.visible = shouldBeVisible;
                }
                if (hiddenBySpace) {
                    artworksToHide.push(artworkChildUserData)
                }
            }

        }
    }
    return artworksToHide
}

